export default {
    approvals: "Approbations",
    delegates: "Délégués",
    employees: "Employés"
}